<p>goal-plan-rating-comment works!</p>
